export default class MenuActions {

    static NEW_DATA = 'NEW_DATA';
    static UPDATE_DATA='UPDATE_DATA';
    static SHOW_DATA='SHOW_DATA';
    static VIEW_DATA='VIEW_DATA';
    static DELETE_DATA='DELETE_DATA';
    static ON_SUBMIT='ON_SUBMIT';
    static ERROR_DATA='ERROR_DATA';
    static PROCESS_DATA='PROCESS_DATA';
    static RESET_DATA='RESET_DATA';
    static SUCCESS_DATA='SUCCESS_DATA';
    static ERROR_SERVER='ERROR_SERVER';
    static RESET_LIST='RESET_LIST';
  
    static submit(){
      return {
        type: MenuActions.ON_SUBMIT
      };
    }
  
    static create(data) {
      return {
        type: MenuActions.NEW_DATA,
        payload: data
      };
    }
  
    static update(data) {
      return {
        type: MenuActions.UPDATE_DATA,
        payload: data
      };
    }
  
    static view(data) {
      return {
        type: MenuActions.VIEW_DATA,
        payload: data
      };
    }
  
    static delete(data) {
      return {
        type: MenuActions.DELETE_DATA
      };
    }
  
    static list(data) {
      return {
        type: MenuActions.SHOW_DATA,
        payload: data
      };
    }
    static resetList() {
      return {
        type: MenuActions.RESET_LIST
      };
    }
    static error(error){
      return {
        type: MenuActions.ERROR_DATA,
        payload: error
      };
    }
    static success(){
      return {
        type: MenuActions.SUCCESS_DATA,
      };
    }
    static process(){
      return {
        type: MenuActions.PROCESS_DATA,
      };
    }
    static reset(){
      return {
        type: MenuActions.RESET_DATA,
      };
    }
    static errorInternal(error){
      return {
        type: MenuActions.ERROR_SERVER,
        payload: error
      };
    }
  }
  
  